import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

export const userService = {
    details,
    signup,
    list,
    updateOnboarding,
    resendVerificationEmail,
    verifyEmail
}

async function details() {

    await checkToken()

    const requestOptions = { method: 'GET', headers: authHeader()}
    return fetch(`${config.apiUrl}/users/details/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function list() {

    await checkToken()

    const requestOptions = { method: 'GET', headers: authHeader()}
    return fetch(`${config.apiUrl}/users/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function signup(body) {

    const requestOptions = { method: 'POST', body }
    
    return fetch(`${config.apiUrl}/users/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function signupFacebook(body) {

    const requestOptions = { method: 'POST', body }
    
    return fetch(`${config.apiUrl}/users/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function updateOnboarding(body) {

    await checkToken()

    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }

    return fetch(`${config.apiUrl}/users/onboarding/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function resendVerificationEmail() {

    await checkToken()

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    }

    return fetch(`${config.apiUrl}/users/resend_verification_email/`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response
        })
}

async function verifyEmail(body) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }

    return fetch(`${config.apiUrl}/users/verify_email/`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response
        })
}
